import { Helmet } from 'react-helmet-async';

const SEO = () => {
  return (
    <Helmet>
      <html lang="es" />
      <title>HEURISTIKO</title>
      <meta name="description" content="Desarrollamos software personalizado para PYMES. Aplicaciones web, móviles e inteligencia artificial. Método heurístico garantizado." />
      <meta name="keywords" content="desarrollo software, software a medida, desarrollo web, aplicaciones móviles, inteligencia artificial, Madrid, PYMES" />
      <meta name="author" content="Heuristiko" />
      <meta property="og:title" content="Heuristiko - Software a Medida" />
      <meta property="og:description" content="Desarrollamos software personalizado para PYMES" />
      <meta property="og:url" content="https://www.heuristiko.com" />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://www.heuristiko.com" />
    </Helmet>
  );
};

export default SEO;